import {
  Box,
  CircularProgress,
  Grid,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import { useTheme } from "@material-ui/styles";
import React, { useContext, useEffect, useState } from "react";
import { useElectronicIdStyles } from "../hooks/useElectronicIdStyles";
import { useElectronicId } from "../hooks/useElectronicId";
import Text from "../../../../../shared/components/Text";
import ReactDOM from "react-dom";
import { ConfigContext } from "../../../../../../contexts/ConfigContext";
import { useGetCustomerSupportDynamicDataTextsByRegistry } from "../constants/useGetCustomerSupportDynamicDataTextsByRegistry";

export default function ElectronicIdWidget({
  selectedDocumentType,
  onSuccess,
  onError,
}) {
  const { breakpoints, palette } = useTheme();
  const {
    state: { registry },
  } = useContext(ConfigContext);
  const isScreenXs = useMediaQuery(breakpoints.down("xs"));
  const { classes } = useElectronicIdStyles();
  const { loading } = useElectronicId({
    selectedDocumentType,
    onSuccess,
    onError,
  });
  const { customerSupportDynamicDataTexts } =
    useGetCustomerSupportDynamicDataTextsByRegistry(registry);

  const [overlayNode, setOverlayNode] = useState(null);

  useEffect(() => {
    if (!customerSupportDynamicDataTexts?.length) return;
    const selector = "eid-button eid-button-primary eid-call-to-action";

    const observer = new MutationObserver(() => {
      const button = document.getElementsByClassName(selector)[0];
      if (!button) return;

      if (
        button.parentElement?.querySelector(
          ".customer-support-information-message"
        )
      )
        return;

      const overlay = document.createElement("div");
      overlay.className = "customer-support-information-message";

      button.parentElement.style.position = "relative";

      button.parentElement.insertBefore(overlay, button);

      setOverlayNode(overlay);
      observer.disconnect();
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, [loading]);

  return (
    <>
      {overlayNode &&
        ReactDOM.createPortal(
          <Box
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
            alignItems="center"
            gridGap={16}
          >
            <Typography color="textSecondary">
              <i className="material-icons-outlined" style={{ fontSize: 18 }}>
                info
              </i>
            </Typography>
            <Typography variant="caption">
              <Text
                tId="VIDEO_ID_ASSISTANCE_MESSAGE"
                dynamicDataTexts={customerSupportDynamicDataTexts}
              />
            </Typography>
          </Box>,
          overlayNode
        )}
      {loading && (
        <div
          style={{
            position: "absolute",
            display: "flex",
            flexGrow: 1,
            alignItems: "center",
            zIndex: 9999,
            left: -1,
            width: "100%",
            height: "100%",
          }}
        >
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            className={"h-100"}
          >
            <Grid item>
              <CircularProgress
                size={90}
                style={{ color: palette.secondary.main }}
                thickness={1.5}
              />
            </Grid>
          </Grid>
        </div>
      )}
      <div
        style={{
          display: "flex",
          flexGrow: 1,
          flexDirection: "column",
        }}
      >
        <Box mb={2}>
          <Typography
            variant="body2"
            style={{ color: palette.text.secondary }}
            align="center"
          >
            <strong>
              <Text tId="FOLLOW_INSTRUCTIONS" />
            </strong>
          </Typography>
        </Box>
        <Box p={isScreenXs ? 0 : 2}>
          <div className={classes.root}>
            <div
              id="video"
              className="align-items-center"
              style={{
                borderRadius: "4px",
                overflow: "hidden",
                minHeight: "472px",
                overflowY: "scroll",
                width: "100%",
              }}
            />
          </div>
        </Box>
      </div>
    </>
  );
}
